import { useNuxtApp } from '#app';
import { BaseService } from '../base/base.service';
import type { IModelResponse } from '../base/dto/base.dto';
import { ModelDepartmentUsers, ModelUserCount } from './dto/user-department.dto';
import {
  ModelUser,
  ModelUserAsso,
  type IModelUserRequest,
} from './dto/user.dto';
import { UserRepository } from './user.repository';

export class UserService extends BaseService {
  private userRepository = new UserRepository(this.api, this.configService);

  async getUser(params: any): Promise<IModelResponse<ModelUser[]>> {
    const { $functions } = useNuxtApp();
    let dataResult: IModelResponse<ModelUser[]> = {
      data: [],
    };
    try {
      const res = await this.userRepository.getUser(params);
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        const dataList = (resData.data || []).map((e) => new ModelUser(e));
        dataResult.data = dataList;
        dataResult.totalItems = resData.totalItems;
        console.log('getUser', resData.data, dataResult);
      }
    } catch (err: any) {
      $functions.notify.error({
        text: err.message,
        isError: true,
      });
      console.log(err, UserService.name);
    }
    return dataResult;
  }

  async getUserAssoById(id: string | number): Promise<ModelUserAsso> {
    let dataResult: ModelUserAsso = new ModelUserAsso();
    try {
      const { $functions } = useNuxtApp();
      const res = await this.userRepository.getUserAssoById(id);
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        dataResult = new ModelUserAsso(resData.data);
        console.log('getUserAssoById', resData.data, dataResult);
      }
    } catch (err) {
      console.log(err, UserService.name);
    }
    return dataResult;
  }

  async createUser(params: IModelUserRequest): Promise<ModelUserAsso> {
    let dataResult: ModelUserAsso = new ModelUserAsso();
    try {
      const { $functions } = useNuxtApp();
      const res = await this.userRepository.createUser(params);
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        dataResult = new ModelUserAsso(resData.data);
        console.log('createUser', resData.data, dataResult);
      }
    } catch (err) {
      console.log(err, UserService.name);
    }
    return dataResult;
  }

  async updateUser(params: IModelUserRequest): Promise<ModelUserAsso> {
    let dataResult: ModelUserAsso = new ModelUserAsso();
    try {
      const { $functions } = useNuxtApp();
      const res = await this.userRepository.updateUser(params);
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        dataResult = new ModelUserAsso(resData.data);
        console.log('updateUser', resData.data, dataResult);
      }
    } catch (err) {
      console.log(err, UserService.name);
    }
    return dataResult;
  }

  async revokeUserKey(id: string | number): Promise<ModelUserAsso> {
   let dataResult: ModelUserAsso = new ModelUserAsso();
    try {
      const { $functions } = useNuxtApp();
      const res = await this.userRepository.revokeAPIKey(id);
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        dataResult = new ModelUserAsso(resData.data);
        console.log('revokeAPIKey', resData.data, dataResult);
      }
    } catch (err) {
      console.log(err, UserService.name);
    }
    return dataResult;
  }

  async changeStatusUser(params: IModelUserRequest): Promise<ModelUserAsso> {
    let dataResult: ModelUserAsso = new ModelUserAsso();
    try {
      const { $functions } = useNuxtApp();
      const res = await this.userRepository.changeStatusUser(params);
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        dataResult = new ModelUserAsso(resData.data);
        console.log('changeStatusUser', resData.data, dataResult);
      }
    } catch (err) {
      console.log(err, UserService.name);
    }
    return dataResult;
  }

  async uploadserAvatar(params: FormData): Promise<any> {
    const { $functions } = useNuxtApp();
    let dataResult;

    try {
      const res = await this.userRepository.uploadUserAvatar(params);
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        dataResult = resData.data;
        console.log('uploadserAvatar', resData.data, dataResult);
      }
    } catch (err: any) {
      $functions.notify.error({
        text: err.message,
      });
      console.log(err, UserService.name);
    }

    return dataResult;
  }

  async getUserAvatar(fileName: string): Promise<any> {
    let dataResult;
    try {
      const res = await this.userRepository.getUserAvatar(fileName);
      const resData = res.data.value;
      if (resData) {
        dataResult = resData;
        console.log('getUserAvatar', fileName, resData, dataResult);
      }
    } catch (err) {
      console.log(err, UserService.name);
    }
    return dataResult;
  }

  async getUserDepartmentList(params: any): Promise<IModelResponse<ModelDepartmentUsers[]>> {
    let dataResult: IModelResponse<ModelDepartmentUsers[]> = {
      data: [],
    };
    try {
      const { $functions } = useNuxtApp();
      const res = await this.userRepository.getUserDepartment(params);
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        const dataList = (resData.data || []).map((e) => new ModelDepartmentUsers(e));
        dataResult.data = dataList;
        dataResult.totalItems = resData.totalItems;
        console.log('getUserDepartmentList', resData.data, dataResult);
      }
    } catch (err) {
      console.log(err, UserService.name);
    }
    return dataResult;
  }

  async getUserCount(): Promise<ModelUserCount> {
    let dataResult: ModelUserCount = new ModelUserCount();
    try {
      const { $functions } = useNuxtApp();
      const res = await this.userRepository.getUserCount();
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        dataResult = new ModelUserCount(resData.data);
        console.log('getUserCount', resData.data, dataResult);
      }
    } catch (err) {
      console.log(err, UserService.name);
    }
    return dataResult;
  }

}
